module.exports = __webpack_public_path__ + "static/img/image-size.2f1b6b18.svg";